//TODO in separate Konstanten dateien auslagern

//Systemvariablen
import {Color} from "three";
import {toFixedFloat} from "./utils/utils";

export let isDebug = false; //TODO: Über .env auslesen
export const setDebugMode = (active) => {
    isDebug = active;
};

export const throttleDuration = 32; //Für target fps 60fps > 1 Refresh pro Frame (1000ms/60frames) = 16.66ms
export const keyThrottleDuration = 250;
export const defaultZoomFactor = 1.2;
export const undoLimit = 5;
export const roundToDecimals = 3; // For rounding numbers
export const defaultPreviewHeight = 4;

//Ordner
export const storageFolder = window.location.origin + "/storage/";
export const blockFolder = storageFolder + "blocks/";
export const modelsFolder = storageFolder + "models/";

//Berechnungswerte
export const HBEBigElementWidth = 0.545;
export const HBESmallElementWidth = 0.345;
export const HBEElementFederWidth = 0.015;
export let HBESectionWidth = HBEBigElementWidth;
export const setHBESectionWidth = (width) => HBESectionWidth = width;
export const HBEWallDefaultThickness = 0.1;
export const HBEMeasureDefaultThickness = 0.05;


//Systemparameter: Default Werte //TODO: Aus Systemparameter im Projektstart festlegen
//Muss aufgerufen werden, wenn ein Parameter geändert wurde.
export function updateSystemParameters() {
    defaultWallElementHeight = parseFloat((defaultRoomHeight + floorConstructionHeight - defaultRaehmHeight - defaultSchwelleHeight).toFixed(roundToDecimals));
    defaultWallHeight = toFixedFloat(defaultRoomHeight + floorConstructionHeight);
}

export const defaultRaehmWidth = 0.1;
export const defaultRaehmHeight = 0.28;

//Reine Raumhöhe in fertigem Haus
export let defaultRoomHeight = 2.52;

export const setDefaultRoomHeight = (value) => {
    if (!isNaN(value)) {
        defaultRoomHeight = value;
    }
};

export const defaultSchwelleWidth = 0.1;
export const defaultSchwelleHeight = 0.1;

//Höhe des Fußbodenaufbaus
export let floorConstructionHeight = 0.21;
export const setFloorConstructionHeight = (value) => {
    if (!isNaN(value)) {
        floorConstructionHeight = value;
    }
};

//Elementegröße ergibt sich aus der Raumhöhe + Fußbodenaufbauhöhe - (Rähmhöhe + Schwellenhöhe).
//Raumhöhe + Fußbodenaufbau ergeben die Gesamthöhe von Boden bis Unterkante des Dachs die abgedeckt werden muss.
//Die Schwelle und das Rähm decken einen Teil davon bereits ab.
export let defaultWallElementHeight = parseFloat((defaultRoomHeight + floorConstructionHeight - defaultRaehmHeight - defaultSchwelleHeight).toFixed(roundToDecimals));
export let defaultWallHeight = toFixedFloat(defaultRoomHeight + floorConstructionHeight);
export const defaultBruestungsRiegelHeight = 0.1;
export const interiorDoorSturzRiegelHeights = {
    smallDoor: 0.2,
    bigDoor: 0.08
};

export const interiorDoorHeights = {
    smallDoor: 2.010,
    bigDoor: 2.135
};

export const interiorDoorWidths = {
    small: 0.78,
    medium: 0.91,
    large: 1.03
};

export let selectedInsideDoorHeight = interiorDoorHeights.smallDoor;

export const setActiveInsideDoorHeight = (height) => {
    if (!isNaN(height)) {
        selectedInsideDoorHeight = height;
    }
};

//UI Werte
export const splitViewportBorderWidth = 4; //px
export const splitViewportSnapDistance = 20; //px

//Farben
export const sceneBackgroundColor = new Color('rgb(235,235,235)');
export const boundingBoxColor = 0xff0000;

export const layers = {
    default: 0,
    wall: 1,
    roof: 2,
    floor: 3,
    raehm: 4,
    schwelle: 5,
    pillars: 6,
    supportBeam: 7,
    cutOuts: 11,
    roomNames: 12,
    furniture: 13,
    roomShapes: 14,
    measurements: 20,
    frontViewOnly: 21,
    rearViewOnly: 22,
    frontAndRearViewOnly: 23,
    leftViewOnly: 24,
    rightViewOnly: 25,
    leftAndRightViewOnly: 26,
    topViewOnly: 27,
    freeViewOnly: 28, //3D
    layoutViewOnly: 29,
    sceneViewOnly: 30,
    hidden: 31
};

//Selectable modes for viewing & placing elements in 3D space
export const modes = {
    view: 0,
    wall: 1,
    moveWall: 2,
    roof: 3,
    floor: 4,
    pillar: 5,
    models: 6,
    cutOut: 7,
    furniture: 8,
    roomSeparation: 9,
    roomLabeling: 10,
    beam: 11,
    measurement:12,
    copyWall:13,
    resizeWall:14,
};

//Currently active mode for 3D space
export let activeMode = modes.view;
export const setActiveMode = (mode) => {
    activeMode = mode;
};

//Cursor
export const cursors = {
    default: "default",
    grab: "grab",
    crosshair: "crosshair",
    cell: "cell",
    none: "none"
};
